import React from 'react';

import { LoginCard } from '@/components/organisms/Auth';
import { LoginLayout } from '@/components/templates/LoginLayout';
import { CmBox, CmHeading, CmText } from '@/components/uiParts';
import { routes } from '@/router';

const ResendEmailRequested = (): JSX.Element => {
  return (
    <LoginLayout>
      <LoginCard>
        <CmHeading fontSize="2xl" mb={5} as="h1">
          {routes.ResendEmailRequested.title}
        </CmHeading>
        <CmBox my={4}>
          <CmText>
            アカウント本登録用のURLを入力いただいたメールアドレスに再送信しました。
          </CmText>
          <CmText>
            メール本文に記載された手順に従いアカウント本登録を行ってください。
          </CmText>
        </CmBox>
      </LoginCard>
    </LoginLayout>
  );
};

export default ResendEmailRequested;
